import { FieldError } from "react-hook-form";
import React from "react";

interface Props {
  errorMessage: any;
}
export default function FormValidationError({ errorMessage }: Props) {
  return (
    <>
      {errorMessage ? (
        <div
          style={{
            fontSize: "smaller",
            color: "red",
          }}
        >
          {errorMessage?.toString()}
        </div>
      ) : null}
    </>
  );
}
